<template>
  <vue-select
    :options="options"
    label="label"
    placeholder="Período"
    :value="value"
    :clearable="true"
    @input="$emit('input', $event)"
  >
    <template slot="option" slot-scope="option">
      {{ option.label }}
    </template>

    <div slot="no-options">Não há opções correspondentes</div>
  </vue-select>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'SelectMes',
  mixins: [utils],
  props: {
    value: {
      type: Object,
      default: null,
    },

    preSelecionarQuadrimestreAtual: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      return [
        this.montarOpcao('Janeiro', [1]),
        this.montarOpcao('Fevereiro', [2]),
        this.montarOpcao('Março', [3]),
        this.montarOpcao('Abril', [4]),
        this.montarOpcao('1º Quadrimestre', [1, 2, 3, 4]),
        this.montarOpcao('Maio', [5]),
        this.montarOpcao('Junho', [6]),
        this.montarOpcao('Julho', [7]),
        this.montarOpcao('Agosto', [8]),
        this.montarOpcao('2º Quadrimestre', [5, 6, 7, 8]),
        this.montarOpcao('Setembro', [9]),
        this.montarOpcao('Outubro', [10]),
        this.montarOpcao('Novembro', [11]),
        this.montarOpcao('Dezembro', [12]),
        this.montarOpcao('3º Quadrimestre', [9, 10, 11, 12]),
      ]
    },
  },
  mounted() {
    // if (this.preSelecionarQuadrimestreAtual && !this.value) {
    //   this.selecionarQuadrimestreAtual()
    // }
  },
  methods: {
    /**
     * Monta uma opção de mês ou quadrimestre para o select.
     *
     * @param {String} label Texto exibido no select.
     * @param {Number[]} meses Lista de meses representados pela opção.
     * @returns {{label: String, value: Number[], nu_ano: Number}}
     */
    montarOpcao(label, meses) {
      return {
        label,
        value: meses,
        nu_ano: this.getAnoReferencia(meses),
      }
    },

    /**
     * Obtém o ano de referência de um período.
     *
     * Caso o primeiro mês do período ainda não tenha ocorrido
     * no ano atual, considera o ano anterior como referência.
     *
     * @param {Number[]} meses Lista de meses do período.
     * @returns {Number} Ano de referência.
     */
    getAnoReferencia(meses) {
      const dataAtual = new Date()
      const mesAtual = dataAtual.getMonth() + 1
      const anoAtual = dataAtual.getFullYear()

      const primeiroMes = Math.min(...meses)

      return primeiroMes <= mesAtual ? anoAtual : anoAtual - 1
    },

    /**
     * Seleciona a opção correspondente ao quadrimestre atual.
     *
     * @returns {void}
     */
    selecionarQuadrimestreAtual() {
      const { quadrimestre } = this.datasQuadrimestre()

      const opcaoQuadrimestre = this.options.find(
        (option) => option.label === `${quadrimestre}º Quadrimestre`
      )

      if (opcaoQuadrimestre) {
        this.$emit('input', opcaoQuadrimestre)
      }
    },
  },
}
</script>
